<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $t('voucher') }}</div>
      <div>
        <router-link class="btn-blue" @click.native="onEditVouchers" to>{{
          $t("edit")
        }}</router-link>
        <router-link class="btn-blue" to="vouchers"
          > {{ $tc("voucher", 1) }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="voucher-card">
      <!-- vouchersObject: {
        voucher_id: null,
        voucher_code: null, // "VO-" + generateRandomCode(8),
        voucher_title: null,
        voucher_description: null,
        cine_id: null,
        selectedCinemasList: [],
        md_id: null,
        selectedMoviesList: [],
        selectedMovie: null,
        voucher_start_date_time: null, // Start_Date,
        voucher_end_date_time: null, // End_date,
        voucher_terms: null,
        voucher_is_active: "Y"
      },-->

      <div class="all-details-container" style="border:2px solid #3876d2">
        <div class="col-12">
          <h3 class="text-blue font-weight-bold mb-3">
            {{ vouchersObject.voucher_title }}
          </h3>

          <div class="mb-4">
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('codes') }} :</span>
              {{ vouchersObject.voucher_code }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('start') }} :</span>
              {{ vouchersObject.voucher_start_date_time | fulldateparse }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('end') }} :</span>
              {{ vouchersObject.voucher_end_date_time | fulldateparse }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('description') }} :</span>
              {{ vouchersObject.voucher_description }}
            </p>

            <h3 class="text-blue font-weight-bold mb-3">
              {{ $t('voucher') }} {{ $t('configurations') }}
            </h3>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('cinemas') }} :</span>
              {{ cinemasList.map((x) => x.cine_name).join(", ") }}.
            </p>

            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('movies') }} :</span>
              {{ movieList.map((x) => x.movie_title).join(", ") }}.
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('client') }} {{ $t('name') }} :</span>
              {{ vouchersObject.client_name }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('client') }} {{ $t('share') }} {{ $t('value') }} :</span>
              {{ vouchersObject.share_value }}
              {{ vouchersObject.share_is_percentage === "Y" ? "%" : "" }}
            </p>

            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('redemptionOutlet') }} :</span>
              {{ $t('redeemAtOnline') }} -
              {{
                vouchersConfiguration.vs_redeem_at_boxoffice ? "Yes" : "No"
              }},&nbsp; {{ $t('redeemAtBoxoffice') }} -
              {{
                vouchersConfiguration.vs_redeem_at_boxoffice ? "Yes" : "No"
              }},&nbsp; {{ $t('redeemAtConcession') }} -
              {{ vouchersConfiguration.vs_redeem_at_boxoffice ? "Yes" : "No" }}
            </p>

            <!-- <p class="mb-1">
              <span class="font-weight-bold mr-1">applicable for :</span>
              Prebook - {{ applicableFor.prebook ? 'Yes': 'No' }},&nbsp;
              Normal - {{ applicableFor.normal ? 'Yes': 'No' }}
            </p> -->

            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('offerValidOnDays') }} :</span>
              {{ DaysList }}.
            </p>

            <p v-if="isValueVoucher == 'Y'" class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('value') }} :</span>
              {{ vouchersConfiguration.voucher_amount }}
              {{
                vouchersConfiguration.voucher_is_percentage === "Y" ? "%" : ""
              }}
            </p>

            <p v-else class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('type') }} :</span>
              {{ $t('buy') }} {{ vouchersConfiguration.voucher_buy_no_of_ticket }} {{ $t('get') }}
              {{ vouchersConfiguration.voucher_get_free_ticket }} {{ $t('tickets') }} {{ $t('free') }}.
            </p>

            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('redeemON') }} :</span>
              {{ vouchersConfiguration.voucherRedeemAmount }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1"
                >{{ $t('minBill_Redemption') }} :</span
              >
              {{ vouchersConfiguration.voucher_min_redemption_amount }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1"
                >{{ $t('maxBillRedemption') }} :</span
              >
              {{ vouchersConfiguration.voucher_max_redemption_amount }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1">{{ $t('voucher') }} {{ $t('partner') }} {{ $t('name') }} :</span>
              {{ vouchersConfiguration.voucherPartnerName }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1"
                >{{ $t('voucherRedemptionperPatron') }} :</span
              >
              {{ vouchersConfiguration.voucher_redemption_per_patron }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold mr-1"
                >Total {{ $t('voucher') }} {{ $t('redemption') }} :</span
              >
              {{ vouchersConfiguration.voucher_total_redemption }}
            </p>

            <p class="mb-1">
              <span class="font-weight-bold mr-1"
                >{{ $t('voucher') }} {{ $t('termsandconditions') }} :</span
              >
              {{ vouchersObject.voucher_terms }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { generateRandomCode } from "@/helper/collection";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
export default {
  data() {
    return {
      // SAIF
      submitted: false,
      cinemasList: [],
      movieList: [],
      voucherPartnerList: [],
      DaysList: "",

      vouchersObject: {
        voucher_id: "",
        voucher_code: "", // "VO-" + generateRandomCode(8),
        voucher_title: "",
        voucher_description: "",
        cine_id: "",
        selectedCinemasList: [],
        md_id: "",
        selectedMoviesList: [],
        selectedMovie: "",
        voucher_start_date_time: "", // Start_Date,
        voucher_end_date_time: "", // End_date,
        voucher_terms: "",
        voucher_is_active: "Y",
        client_name: "",
        share_value: null,
        share_is_percentage: "Y",
      },
      isValueVoucher: "Y",
      vouchersConfiguration: {
        vs_redeem_at_boxoffice: true,
        vs_redeem_at_concession: false,
        vs_redeem_at_online: false,

        voucherPartnerName: null,
        vp_id: null,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: null,
        voucher_is_percentage: "Y",
        voucher_buy_no_of_ticket: null,
        voucher_get_free_ticket: null,
        voucher_min_redemption_amount: null,
        voucher_max_redemption_amount: null,
        voucherRedeemAmount: "voucherRedeemNetAmount",
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
      },
      weekDays: {
        selectAll: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },

      applicableFor: {
        // all: false,
        prebook: true,
        normal: false,
      },
      weekdayerror: "",
      reedemerror: "",
      applicableerror: "",
      // SAIF
    };
  },
  watch: {},
  beforeMount() {
    const { voucher_id } = this.$route.query;
    if (voucher_id) {
      this.getVoucherDetails(voucher_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    // SAIF
    onEditVouchers: function (voucher_id) {
      this.$router.push({
        path: "/marketing/edit-vouchers",
        query: { voucher_id: this.vouchersObject.voucher_id },
      });
    },
    getVoucherDetails: function (voucher_id) {
      MarketingService.GetSingleVoucher({ voucher_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            // console.log("data. :", data.Records);
            if (data.Records.length > 0) {
              let Records = data.Records[0];
              this.setVoucherConfiguration(Records);
              if (Records.client_id) {
                this.setClientName(Records.client_id);
              }
              this.vouchersObject = {
                voucher_id: Records.voucher_id,
                voucher_code: Records.voucher_code, // "VO-" + generateRandomCode(8),
                voucher_title: Records.voucher_title,
                voucher_description: Records.voucher_description,
                cine_id: null,
                share_value: Records.client_share_value || null,
                share_is_percentage: Records.client_share_is_percentage || "Y",
                selectedCinemasList: [],
                md_id: null,
                selectedMoviesList: [],
                voucher_start_date_time: Records.voucher_start_date_time, // Start_Date,
                voucher_end_date_time: Records.voucher_end_date_time, // End_date,
                voucher_terms: Records.voucher_terms || null,
                voucher_is_active: Records.vp_is_active || "Y",
                client_name: "",
              };

              this.cinemasList = data.voucherCinemas;
              this.movieList = data.voucherMovies;
              this.setDaysValue(data.voucherDays);

              this.applicableFor = {
                prebook:
                  Records.vs_applicable_for_prebook === "Y" ? true : false,
                normal: Records.vs_applicable_for_normal === "Y" ? true : false,
              };
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    setDaysValue: function (voucherDays) {
      this.DaysList = "";
      let days = {
        sunday: "pvds_sunday",
        monday: "pvds_monday",
        tuesday: "pvds_tuesday",
        wednesday: "pvds_wednesday",
        thursday: "pvds_thursday",
        friday: "pvds_friday",
        saturday: "pvds_saturday",
      };
      Object.keys(days).map((x, index) => {
        let text = index !== Object.keys(days).length - 1 ? x + ", " : x;
        if (
          voucherDays &&
          voucherDays.length > 0 &&
          voucherDays[0][days[x]] === "Y"
        ) {
          this.DaysList += text;
        }
      });
    },
    setClientName: function (client_id) {
      ClientService.GetSingleClientDetails({ client_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.vouchersObject.client_name = obj.client_name;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    setVoucherConfiguration: function (Records) {
      this.isValueVoucher = Records.is_voucher_type_value || "Y";
      this.vouchersConfiguration = {
        vs_redeem_at_boxoffice:
          Records.vs_redeem_at_boxoffice === "Y" ? true : false,
        vs_redeem_at_concession:
          Records.vs_redeem_at_concession === "Y" ? true : false,
        vs_redeem_at_online: Records.vs_redeem_at_online === "Y" ? true : false,

        voucherPartnerName: Records.vp_partner_name,
        vp_id: Records.vp_id,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: Records.voucher_amount || null,
        voucher_is_percentage: Records.voucher_is_percentage || "Y",
        voucher_buy_no_of_ticket: Records.voucher_buy_no_of_ticket,
        voucher_get_free_ticket: Records.voucher_get_free_ticket,
        voucher_amount: Records.voucher_amount || null,
        voucher_is_percentage: Records.voucher_is_percentage || "Y",
        voucher_min_redemption_amount:
          Records.voucher_min_redemption_amount || null,
        voucher_max_redemption_amount:
          Records.voucher_max_redemption_amount || null,
        voucherRedeemAmount: null,
        voucher_redemption_per_patron:
          Records.voucher_redemption_per_patron || null,
        voucher_total_redemption: Records.voucher_total_redemption || null,
      };
      if (
        Records.voucher_redeem_on_net &&
        Records.voucher_redeem_on_net === "Y"
      ) {
        this.vouchersConfiguration.voucherRedeemAmount = "Net Amount";
      } else if (
        Records.voucher_redeem_on_gross &&
        Records.voucher_redeem_on_gross === "Y"
      ) {
        this.vouchersConfiguration.voucherRedeemAmount = "GrossAmount";
      }
    },
    // SAIF
  },
};
</script>
 



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/viewVouchers.vue